var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerA1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LocationMarker_A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LocationMarker_A1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C7.12875,0 0,6.34195455 0,14.1673636 C0,21.9909091 3.75,27.9545455 15,41 C26.25,27.9545455 30,21.9909091 30,14.1673636 C30,6.34195455 22.873125,0 15,0 Z",
    id: "Shape",
    fill: "#124B4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A1",
    transform: "translate(4.914062, 8.531250)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4296875,11.46875 L7.6015625,8.75 L3.4375,8.75 L2.609375,11.46875 L0,11.46875 L4.03125,0 L6.9921875,0 L11.0390625,11.46875 L8.4296875,11.46875 Z M7.0234375,6.71875 C6.2578125,4.25520833 5.82682292,2.86197917 5.73046875,2.5390625 C5.63411458,2.21614583 5.56510417,1.9609375 5.5234375,1.7734375 C5.3515625,2.44010417 4.859375,4.08854167 4.046875,6.71875 L7.0234375,6.71875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6484375,11.46875 L15.234375,11.46875 L15.234375,4.859375 L15.2578125,3.7734375 L15.296875,2.5859375 C14.8958333,2.98697917 14.6171875,3.25 14.4609375,3.375 L13.1484375,4.4296875 L11.984375,2.9765625 L15.6640625,0.046875 L17.6484375,0.046875 L17.6484375,11.46875 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerA1);
export default __webpack_public_path__ + "static/media/LocationMarker_A1.c124fa2dad3d6d4b64233552e6d54096.svg";
export { ForwardRef as ReactComponent };